/* eslint-disable react/jsx-closing-bracket-location */
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles/variant-selector.scss';

const VariantSelector = (props) => {
    const { variants, currentVariant } = props;
    return (currentVariant && (
        <DropdownButton
            as="button"
            title={currentVariant.attributes.options_text}
            id="variantSelector">
            {variants.map((variant) => (
                <MenuItem
                    as="button"
                    className={`button-secondary inv button-small ${styles.variantItem}`}
                    id={variant.id}
                    key={variant.id}
                    onSelect={() => {
                        props.onVariantSelected(variant);
                    }}>
                    {variant.attributes.options_text}
                    {!variant.attributes.in_stock && (
                        <span>
                            &nbsp;&nbsp;-&nbsp;
                            (
                            <FormattedMessage id="out-of-stock" defaultMessage="Out of stock" />
                            )
                        </span>
                    )}
                </MenuItem>
            ))}
        </DropdownButton>
    ));
};

export default VariantSelector;



/** WEBPACK FOOTER **
 ** ./src/components/product/variant-selector.js
 **/